/**
 * @version 1.0.1
 * @author wuwg  <wuwg@thunisoft.com>
 * @createTime:2019-08-13,
 * @updateTime:2019-08-13
 * @copyright thunisoft fd
 * @description  *  [jsDoc中文文档]{@link  http://www.dba.cn/book/jsdoc/JSDOCKuaiBiaoQianBLOCKTAGS/CONSTRUCTS.html}
 *  [jsdoc-vuejs]{@link  http://npm.taobao.org/package/jsdoc-vuejs}  -
 *  [个人博客]{@link  http://www.wuweigang.com}
 */
import ccTab from '@/components/common/tab/index.vue';

export default {
    name: 'xq',
    components: {ccTab},
    data() {
        return {
            tabList: [
                {
                    name: '指导性案例',
                    code: 'zdxal'
                },
                {
                    name: '年度案例精选',
                    code: 'ndaljx'
                },
                {
                    name: '公报案例',
                    code: 'gbal'
                }
            ],
            activeTab: 'zdxal',
            data:[]
        };
    },
    computed: {
        crumbsList() {
            const list = [{
                name:'审判研究',
                key:'hsal',
                path:'/hsal'
            }];
            const listItem = this.tabList.filter(item => item.code === this.activeTab)[0];
            listItem.key = listItem.code;
            list.push(listItem);
            list.push({
                name:'案例详情',
                key:'alxq'
            });
            return Object.freeze(list);
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.activeTab = this.$route.query.tab || 'zdxal';
        },
        // 截取信息加'...'
        getMsg(msg) {
            const strLength = 145;
            return msg.length > strLength ? `${msg.substring(0, strLength)}...` : msg;
        },
        // 页签切换
        handelTabChange(code) {
            this.activeTab = code;
        }
    }
};

